import React, { Component } from "react";
import { GoPencil } from "react-icons/go";
import Popup from "reactjs-popup";
class PaymentLinksPopup extends Component {
  constructor() {
    super();
    this.state = {
      isPopupOpen: false,
      amount: "",
      description: "",
      customer_name: "",
      customer_number: "",
      customer_email: "",
      email_notify: false,
      sms_notify: false,
      reference_id: "",
      expire_by: "",
      error: "",
    };
    this.initialState = this.state;
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState(this.initialState);
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  onToggleCheckbox = (e) => {
    this.setState({ [e.target.id]: !this.state[e.target.id] });
  };

  componentDidMount() {
    this.setState({
      reference_id: this.props?.data?.receipt,
      expire_by: this.props?.data?.link_expire_by?.substr(0, 10),
    });
  }

  editLinkAndClosePopup = () => {
    let data = {
      link_id: this.props.data.link_id,
    };

    if (this.props.data.receipt !== this.state.reference_id) {
      data.reference_id = this.state.reference_id;
    }

    if (this.props.data.link_expire_by !== this.state.expire_by) {
      data.expire_by = this.state.expire_by;
    }

    this.props.editLink(data, (res) => {
      console.log("props here", this.props);
      console.log("data", res?.response?.data?.success === false);
      if (res?.response?.data?.success === false) {
        this.setState({ error: res.response.data.error.reason });
      } else {
        console.log("res", res?.data?.response?.result);
        this.setState(this.initialState);
      }
    });
  };

  render() {
    return (
      <React.Fragment>
        <GoPencil onClick={this.openPopup} style={{ fontSize: "22px" }} />
        <Popup
          open={this.state.isPopupOpen}
          onClose={this.closePopup}
          closeOnDocumentClick={false}
        >
          <div className="Modal" style={{ textAlign: "center" }}>
            <div style={{ margin: "10px 0" }}>
              <input
                type="number"
                value={this.props.data.amount / 100}
                id="amount"
                placeholder="Amount"
                disabled={true}
              />
              <span
                style={{ color: "red", fontSize: "18px", marginLeft: "2px" }}
              >
                *
              </span>
              <input
                value={this.props.data.description}
                id="description"
                placeholder="Description"
                disabled={true}
              />
              <span
                style={{ color: "red", fontSize: "18px", marginLeft: "2px" }}
              >
                *
              </span>
            </div>
            <div style={{ margin: "10px 0" }}>
              <label style={{ width: "100%", margin: "0" }}>
                <strong>Customer Details</strong>
              </label>
              <input
                id="customer_name"
                value={this.props.data.customer_name}
                placeholder="Customer Name"
                disabled={true}
              />
              <div>
                <input
                  id="customer_email"
                  value={this.props.data.customer_email}
                  onChange={this.onChange}
                  placeholder="Customer Email"
                  disabled={true}
                />
                <input
                  id="customer_number"
                  value={this.props.data.customer_number}
                  onChange={this.onChange}
                  placeholder="Customer Contact Number"
                  disabled={true}
                />
              </div>
            </div>
            <div>
              <label style={{ width: "100%", margin: "0" }}>
                <strong>Notify By</strong>
              </label>
              <label>
                <input
                  style={{ marginRight: "4px" }}
                  id="email_notify"
                  defaultChecked={this.props.data.email_notify}
                  onChange={this.onToggleCheckbox}
                  type="checkbox"
                  disabled={true}
                />
                Email
              </label>
              <label style={{ marginLeft: "20px" }}>
                <input
                  id="sms_notify"
                  style={{ marginRight: "4px" }}
                  defaultChecked={this.props.data.sms_notify}
                  onChange={this.onToggleCheckbox}
                  type="checkbox"
                  disabled={true}
                />
                Number
              </label>
            </div>
            <div style={{ margin: "10px 0" }}>
              <label style={{ margin: "0" }}>
                <strong>Receipt no / Reference Id</strong>
              </label>
              <input
                id="reference_id"
                onChange={this.onChange}
                value={this.state.reference_id}
                placeholder="Reference id /receipt no"
              />
            </div>
            <div>
              <label style={{ width: "100%", margin: "0" }}>
                <strong>Link Expiry</strong>
              </label>

              <input
                id="expire_by"
                type="date"
                onChange={this.onChange}
                value={this.state.expire_by}
              />
            </div>

            <p style={{ color: "red" }}>{this.state.error}</p>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <button onClick={this.editLinkAndClosePopup}>Save</button>
              <button onClick={this.closePopup}>Close</button>
            </div>
          </div>
        </Popup>
      </React.Fragment>
    );
  }
}

export default PaymentLinksPopup;
